class Block {
  constructor(block) {
    this.el = $(block);
    this.elements = {
      location: this.el.find('.block-navigation-side__nav-link.-location'),
    },

    this.initSearch();
    this.initLocation();
  }

  initSearch() {
    const searchTrigger = this.el.find('[data-trigger="search"]');
    const searchItem =  this.el.find('[data-element="search"]');

    if (searchTrigger && searchItem) {
      searchTrigger.on('click', () => {
        searchItem.fadeToggle(200);
        searchItem.parent().toggleClass('-search-active');
      });
    }
  }

  initLocation() {
    $(document).on('bvm_config_ready', () => {
      if (this.elements.location.length > 0) {
        const parts = [];

        if (window.bvm.user.location.city) {
          parts.push(window.bvm.user.location.city);
        }

        if (window.bvm.user.location.region_code) {
          parts.push(window.bvm.user.location.region_code);
        }

        this.elements.location.html(parts.join(', '));
      }

      if (window.bvm.user.location.country) {
        this.el.addClass(`-location-${window.bvm.user.location.country.toLowerCase()}`);
      }

      this.el.addClass('-initialized');
    });
  }
}

class NavigationSide {
  constructor(document = window.document) {
    this.blocks = document.querySelectorAll('[data-block="navigation-side"]');

    if (0 !== this.blocks.length) {
      this.blocks.forEach(block => {
        new Block(block);
      });
    }
  }
}

$(document).on(`bvm_front_ready`, () => {
  new NavigationSide();
});

$(document).on('bvm_blocks_navigation-side_init', (event, document) =>  {
  if ('function' === typeof document.querySelectorAll) {
    new NavigationSide(document);
  }
})
